import { RoleKind } from '../models/brijjsports.enums';

/**
 * A mock user account derived from a tenant's seeded data. Every Owner /
 * Coach / Parent / Athlete is a user of their tenant. There is no role
 * picker — the role and tenant are determined by which account signs in.
 */
export interface MockUser {
  /** Stable id (tenantId + role + refId or 'owner'). */
  id: string;
  email: string;
  password: string;
  name: string;
  role: RoleKind;
  tenantId: string;
  tenantSlug: string;
  tenantName: string;
  /** Coach / Parent / Athlete record id; null for Owner. */
  refId: string | null;
}

/** Shared mock password for every demo account. */
export const MOCK_PASSWORD = 'demo1234';
